export default __webpack_public_path__ + "static/media/arrows.e3540c93.svg";